<template>
  <div class="key_value">
    <p class="key_value--label text-uppercase">{{ label }}</p>
    <p style="word-break: break-word;">
      <a v-if="isUrl" :href="formattedValue" target="_blank">{{ formattedValue }}</a>
      <template v-else>{{ formattedValue }}</template>
    </p>
  </div>
</template>

<script>
import dates from "../../services/dates";
import utils from "../../services/utils";

export default {
  name: "AppKeyValueItem",
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean],
    },
    isDate: {
      type: Boolean,
      default: false
    },
    isTime: {
      type: Boolean,
      default: false
    },
    isCurrency: {
      type: Boolean,
      default: false
    },
    isUrl: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedValue() {
      if (this.value && typeof this.value === 'number' && this.isCurrency) {
        return utils.formatCurrency(this.value);
      }

      if (this.value && this.isDate) {
        /**
         * When dates are given to frontend and not in a timestamp then we get a Not a Date error
         * This checks for "/" in the date and use JS Date to convert to a timestamp which is our standard
         * The reason for this is custom fields can't be Carbon instances via backend
         * due to being inside a JSON object
         */
        if ((typeof this.value === 'string' || this.value instanceof String) && this.value.includes('/')) {
          return dates.getJSDate(new Date(this.value).toISOString())
        }

        return dates.formatAsDate(this.value)
      }

      if (this.value && this.isTime) {
        return dates.formatAsTime(this.value, false)
      }

      return this.value ? this.value : '--';
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.key_value {
  margin-top: 1.25rem;

  &--label {
    margin-bottom: 6px;
    font-size: 0.625rem;
    color: $text-muted;
  }
}
</style>
